import { useRef, useState, useEffect, MutableRefObject } from "react";
import { Input, Pagination } from "@qastanfit/qastan-ui"
import ManagementTable from "./ManagementTable";

import styles from "../../../styles/pages/Management.module.scss";

import plus from "../../../assets/icons/plus_white.svg";
import search from "../../../assets/icons/search.svg";
import edit from "../../../assets/icons/edit_white.svg";
import trash from "../../../assets/icons/trash_white.svg";
import mail from "../../../assets/icons/mail_white.svg";
import menu from "../../../assets/icons/menu_white.svg";
import { isChild } from "../../../functions/general/checks";

import Detail from "../../../components/Detail";
import EditUser from "./EditUser";
import Popup from "../../../components/Popup";
import DeleteUser from "./DeleteUser";
import AddUser from "./AddUser";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux";
import { setNotification } from "../../../redux/actions";
import { handleSendMail } from "../../../functions/fetch/user";
import { splitArrayInPieces } from "../../../functions/general/pagination";

import { motion, AnimatePresence } from "framer-motion"
import { RootState } from "../../../store";

const UserManagement : React.FC = () => {
    const dispatch = useAppDispatch();
    const users = useAppSelector((state:RootState) => state.users)
    const userdata:UserData = useAppSelector((state:RootState) => state.userdata);

    const tasksRef = useRef() as MutableRefObject<HTMLDivElement>

    const [showAdd, setshowAdd] = useState<Boolean>(false);
    const [showDelete, setshowDelete] = useState<Boolean>(false);
    const [showEdit, setshowEdit] = useState<Boolean>(false);
    const [showTasks, setshowTasks] = useState<Boolean>(true);

    const [selectedUser, setselectedUser] = useState<User | null>();
    const [prevSelectedUser, setprevSelectedUser] = useState<User | null>(null);

    const [currentPage, setcurrentPage] = useState(1);
    const [tableUsers, settableUsers] = useState<Users[]>();

    const handleClickOutside = (e:any) => {
        let tr = tasksRef.current;
        if(tr){
            if(!isChild(tr, e.target) && e.target.id !== "openTask"){
                setshowTasks(false);
            } 
        }
    };

    useEffect(() => {
        document.addEventListener('touchstart', handleClickOutside);
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('touchstart', handleClickOutside);
            document.removeEventListener('click', handleClickOutside);
        }
    }, []);

    useEffect(()=>{
        if(selectedUser){
            setprevSelectedUser(selectedUser)
        }
    }, [selectedUser])

    useEffect(()=>{
        if(users){
            let u = splitArrayInPieces(users, 10);
            settableUsers(u);
        }
    }, [users])

    const sendMail = async () => {
        if(prevSelectedUser){
            dispatch(setNotification({type:"pending", title:"Mail versturen", message:"Even geduld..."}))
            let m = await handleSendMail(prevSelectedUser?.apiuserid, userdata)
            if(m.errorcode === 0){
                dispatch(setNotification({type:"success", title:"Succes", message:"De registratie mail is opnieuw verstuurd"}))
            }
            else {
                console.error(m)
                dispatch(setNotification({type:"error", title:"Mislukt", message:"Mail versturen is mislukt"}))
            }
        }
    }

    const searchUser = (value:string) => {
        // let tmp = [...users];
        // let r:Users = [];

        // tmp.forEach(user => {
        //     if(user.firstname.toLowerCase().includes(value.toLowerCase()) || user.lastname.toLowerCase().includes(value.toLowerCase()) || user.username.toLowerCase().includes(value)){
        //         r.push(user)
        //     }
        // });
        // let result:Users[] = splitArrayInPieces(r, 10)

        // settableUsers(result);
    }

    return (
        <>
        {showAdd &&
            <Detail onClose={()=>{setshowAdd(false)}}>
                <AddUser onAdd={()=>{setshowAdd(false)}}/>
            </Detail>
        }

        {showEdit && 
            <Detail onClose={()=>{setshowEdit(false)}}>
                <EditUser onEdit={()=>{setshowEdit(false)}} user={prevSelectedUser}/>
            </Detail>
        }

        {showDelete &&
            <Popup>
                <DeleteUser onClose={()=>{setshowDelete(false)}} user={prevSelectedUser}/>
            </Popup>
        }

        <div className={styles.management}>
            <h1>Gebruikersbeheer</h1>

            <div className={styles.table} style={{marginTop:"2rem"}}>
                <div className={styles.header}>
                    <Input onChange={(element:HTMLInputElement)=>{searchUser(element.value)}} size="compact" placeholder="Zoek gebruiker..." startEnhancer={<img className={styles.search_icon} src={search} alt="search"/>}/>
                    <Pagination size="compact" currentPage={currentPage} numPages={tableUsers?.length} onChange={(num:number)=>{setcurrentPage(num)}} labelNumPages="van de" prevText="Prev" nextText="Next"/>
                </div>

                {tableUsers && <ManagementTable users={tableUsers[currentPage-1]} onViewDetail={()=>{}} onSelectUser={(user)=>{setselectedUser(user)}}/>}
            </div>
        </div>

            <button id="openTask" onClick={()=>{setshowTasks(true)}} className={styles.mobile_tasks_button}><img id="openTask" src={menu} alt="menu"/></button>
            <div ref={tasksRef} className={`${styles.tasks} ${!showTasks && styles.tasks_hide}`}>

                <button onClick={()=>{setshowAdd(true)}} className={`${styles.task} ${styles.task_green}`}>
                    <div className={styles.icon}>
                        <img src={plus} alt="new"/>
                    </div>
                    <p className={styles.label}>Nieuw</p>
                </button>
                

                <AnimatePresence>
                {(selectedUser) && 
                <motion.button onClick={()=>{setshowEdit(true)}} className={`${styles.task} ${styles.task_orange}`} animate={{scale:1, opacity:1}} initial={{scale:.9, opacity:0}} exit={{scale:.9, opacity:0}} transition={{ease:"backInOut", duration:.3}}>
                    <div className={styles.icon}>
                        <img src={edit} alt="edit"/>
                    </div>
                    <p className={styles.label}>Wijzigen</p>
                </motion.button>
                }
                </AnimatePresence>

                <AnimatePresence>
                {(selectedUser) && 
                <motion.button onClick={()=>{setshowDelete(true)}} className={`${styles.task} ${styles.task_red}`} animate={{scale:1, opacity:1}} initial={{scale:.9, opacity:0}} exit={{scale:.9, opacity:0}} transition={{ease:"backInOut", duration:.3}}>
                    <div className={styles.icon}>
                        <img src={trash} alt="delete"/>
                    </div>
                    <p className={styles.label}>Verwijder</p>
                </motion.button>
                }
                </AnimatePresence>
                
                <AnimatePresence>
                {(selectedUser && !selectedUser.verified) &&
                <motion.button onClick={()=>{ sendMail() }} className={`${styles.task} ${styles.task_purple}`} animate={{scale:1, opacity:1}} initial={{scale:.9, opacity:0}} exit={{scale:.9, opacity:0}} transition={{ease:"backInOut", duration:.3}}>
                    <div className={styles.icon}>
                        <img src={mail} alt="mail"/>
                    </div>
                    <p className={styles.label}>Verstuur mail</p>
                </motion.button>
                }
                </AnimatePresence>
            </div>
        </>
    )
}

export default UserManagement;